import { Button, DialogContent, Typography } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';

import styles from './LogoutRequiredDialog.module.scss';
import { InfoIcon } from 'assets';

export interface LogoutRequiredDialogProps extends DialogProps {
  onConfirm: () => void;
  onClose?: () => void;
}

export function LogoutRequiredDialog({ onConfirm, onClose, ...rest }: LogoutRequiredDialogProps) {
  const { t } = useTranslation('auth');

  return (
    <Dialog {...rest} className={styles.dialog}>
      <DialogContent>
        <InfoIcon className={styles.icon} />

        <Typography color='error' variant='body4'>
          {t('logoutRequiredDialog.title')}
        </Typography>

        <Typography variant='body2'>{t('logoutRequiredDialog.description')}</Typography>

        <div className={styles.buttons}>
          <Button variant='outlined' onClick={onClose}>
            {t('logoutRequiredDialog.goBack')}
          </Button>

          <Button variant='contained' onClick={onConfirm}>
            {t('logoutRequiredDialog.logout')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
